export default "/assets/images/chart-sm-05.59f219d60c9ac7ac.svg";